var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "display-shown-items-count" }, [
    _vm._v(" Показано"),
    _c("b", [_vm._v(" " + _vm._s(_vm.shownItemsCount) + " ")]),
    _vm._v(" из "),
    _c("b", [_vm._v(" " + _vm._s(_vm.totalItemsCount) + " ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }